import { defineVariants } from "@/runtime/style-engine/define-variants";

export const skeletonClasses = defineVariants({
  base: `bg-(--color-elevation-200)/50`,
  variants: {
    variant: {
      line: `h-4 w-full rounded`,
      circle: `rounded-full aspect-square`,
      rect: `rounded-lg`,
    },
    animated: {
      true: `animate-pulse`,
      false: ``,
    },
  },
  defaults: {
    variant: "line",
    animated: "true",
  },
});
